"use client";

import { useState, useEffect } from "react";
import Link from "next/link"; // Import Link component
import config from "../../../config/announcement.json"; // Import the config file
import appLinks from "../../../config/appLinks.json"; // Import app links

const AnnouncementBar = () => {
  const [showBar, setShowBar] = useState(false);

  // Read config settings
  const { enabled, text, linkText } = config.announcementBar;
  const linkUrl = appLinks.contactBookingLink; // Use contact booking link from appLinks

  useEffect(() => {
    // Only proceed if the bar is enabled in config
    if (enabled) {
      // Check localStorage or other conditions if needed (e.g., for dismissal)
      // const wasDismissed = localStorage.getItem('announcementDismissed') === 'true';
      const shouldShow = true; // Replace with actual dismissal logic if needed
      setShowBar(shouldShow);
    }
  }, [enabled]); // Re-run if enabled status changes (though unlikely for config)

  // Don't render if not enabled in config or if dismissed (based on showBar state)
  if (!showBar) {
    return null;
  }

  return (
    <div className="w-full bg-gradient-to-r from-blue-900 to-blue-800 text-white py-2 text-center relative overflow-hidden z-50">
      <p className="text-sm">
        {text}{" "}
        {linkUrl && linkText && ( // Only show link if URL and text are provided
          <Link
            href={linkUrl}
            className="text-white hover:text-blue-200 font-medium transition-colors ml-1 underline"
          >
            {linkText} &rarr;
          </Link>
        )}
      </p>
      {/* Optional: Close button can set showBar to false and potentially localStorage */}
    </div>
  );
};

export default AnnouncementBar; 